import * as React from 'react';
import { useCallback, useState } from 'react';
import { compose, defaultProps, pure } from 'recompose';
import AppBar from '@material-ui/core/AppBar';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Close from '@material-ui/icons/Close';
import Menu from '@material-ui/icons/Menu';
import { Text } from '../Text';
import { withStyles } from '@material-ui/core';
import styles from './HeaderStyles';
import Sidebar from './Sidebar';
const RightIcons = (props) => {
    const { classes, rightElements } = props;
    return rightElements.map((rightEl, index) => (React.createElement("div", { className: classes.buttonContainer, onClick: () => rightEl.onClick(), role: "button", tabIndex: index, key: rightEl.id },
        React.createElement("img", { alt: rightEl.label, className: classes.icon, src: rightEl.icon }),
        React.createElement("div", { className: classes.label }, rightEl.label))));
};
const Header = (props) => {
    const { classes, title, appList, activeApp, toggledOn, hide, toggle, logoIcon, children, appVersion, hideAppLabels, showNotificationBadge = false, testId = 'Header', } = props;
    const [sidebarIsVisible, setSidebarIsVisible] = useState(false);
    const handleClick = useCallback(() => {
        setSidebarIsVisible((prev) => !prev);
    }, [setSidebarIsVisible]);
    const handleClickAway = useCallback(() => {
        setSidebarIsVisible(false);
    }, [setSidebarIsVisible]);
    const hamburgerIcon = sidebarIsVisible ? (React.createElement(Close, { className: classes.menuIcon })) : (React.createElement(Menu, { className: classes.menuIcon }));
    const openSideMenuButton = (React.createElement(IconButton, { "data-testid": `${testId}-openSideMenuButton`, "aria-label": "Menu", onClick: handleClick }, hamburgerIcon));
    return (React.createElement("div", { "data-testid": testId },
        appList && (React.createElement(ClickAwayListener, { touchEvent: 'onTouchStart', disableReactTree: true, mouseEvent: 'onMouseUp', onClickAway: handleClickAway },
            React.createElement(Slide, { direction: "right", in: sidebarIsVisible, mountOnEnter: true },
                React.createElement(Sidebar, { show: true, appsList: appList, activeApp: activeApp || '', appVersion: appVersion, hideAppLabels: hideAppLabels })))),
        React.createElement(AppBar, { className: classes.appBar, color: "primary" },
            React.createElement(Toolbar, { className: classes.appToolBar },
                appList && openSideMenuButton,
                logoIcon && React.createElement("img", { src: logoIcon, alt: "logo", className: classes.logo }),
                React.createElement(Text, { className: classes.title }, title),
                children,
                RightIcons(props)))));
};
const ComposedHeader = compose(withStyles(styles, { withTheme: true }), pure, defaultProps({
    title: '',
    rightElements: [],
    activeApp: '',
    logoIcon: '',
}))(Header);
ComposedHeader.displayName = 'Header';
export default ComposedHeader;
//# sourceMappingURL=Header.js.map